<div class="heading heading_small">
  <img
    src="assets/icon-download.svg"
    width="110"
    height="104"
    alt="Download icon"
  />
  Downloads
</div>

@if ({ orders: orders$ | async }; as asyncResult) {
  @if (asyncResult.orders && asyncResult.orders.length > 0) {
    <div class="table table_grid border-radius" [class.mb30]="mb30">
      @for (
        order of partialView
          ? asyncResult.orders!.slice(0, 6)
          : asyncResult.orders;
        track order.id
      ) {
        <div class="table__item">
          <div>
            <a [href]="order.download_url" target="_blank">
              <img
                [src]="order.thumbnail.url"
                [width]="order.thumbnail.width"
                [height]="order.thumbnail.height"
                [alt]="order.title"
              />
            </a>
          </div>
          <div>
            <div>
              <div class="content-type">{{ order.type }}</div>
            </div>
            <div>{{ order.created_at | date: 'dd.MM.yyyy' }}</div>
            <div>{{ order.amount | price }}</div>
          </div>
          <div>
            <a [href]="order.download_url" download>
              <img
                src="assets/icon-download.svg"
                width="110"
                height="104"
                alt="Download icon"
              />
            </a>
          </div>
        </div>
      }

      @if (partialView) {
        @if (asyncResult.orders && asyncResult.orders.length > 6) {
          <div class="account__more">
            <a
              routerLink="downloads"
              class="button button_dark button_standard"
            >
              All downloads
            </a>
          </div>
        }
      } @else {
        @if (hasMoreResults$ | async) {
          <app-gallery-items-load-more (loadMore)="onLoadMore()" />
        }
      }
    </div>
  } @else {
    <app-empty-block title="You have not purchased any videos at the moment.">
      <p>
        Explore our extensive selection of stock videos in our database and find
        the perfect high-quality content for yourself.
      </p>
    </app-empty-block>
  }
}
